import packageInfo from '../../package.json';

export default (assetName: string) =>
  `/${packageInfo.homepage}/assets/${assetName}`;
